module.exports = __webpack_public_path__ + "static/media/bg.31a470ab.png";